import { dataShieldCnySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldCnySolid = /*#__PURE__*/createIcon(dataShieldCnySolid)
export default IconShieldCnySolid
